import {ThirdPartyTokenChannel} from "@irati/types"
import PBService from "../../services"
import client, {MutationOptions} from "../../services/apollo"
import tokenQuery, {tokenKey} from "./queries/token"
import {intercomJwtKey, intercomJwtQuery} from "./queries/jwt"

class IntercomToken extends PBService {
  get(channel: ThirdPartyTokenChannel, options: MutationOptions = {}) {
    return client.query({...options, variables: {channel}, query: tokenQuery}).then(({data}) => data[tokenKey])
  }

  getJwt(channel: ThirdPartyTokenChannel): Promise<string | null> {
    // a jwt expires, so it must never come from the apollo cache
    return client
      .query({variables: {channel}, query: intercomJwtQuery, fetchPolicy: "network-only"})
      .then(({data}) => data[intercomJwtKey])
  }
}

const intercomTokenService = new IntercomToken({errorHandlers: []})

export default intercomTokenService
